<template>
  <div class="deduct-set-form">
    <drawer :title="updateTitle" :dialogShow="updateDeductHide" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <div class="deduct-tops">
            <div>
              <div class="order-title-boxs">
                <span class="blueBlock"></span>
                <div><i>提成总金额</i><span class="money">￥{{ setDeductAmount }}</span></div>
                <div><i>社保补贴总金额</i><span class="money">￥{{ socialSubsidyTotalAmount }}</span></div>
              </div>
            </div>
            <el-button class="btns small-btn" type="primary" @click="addDeductStaffList">新增技师</el-button>
          </div>
          <div class="deduct-boxs" v-for="(item,index) in deductStaffList" :key="index">
            <div class="deduct-rows rows">
              <el-row>
                <el-col :span="4">
                  <p class="label">技师:</p>
                </el-col>
                <el-col :span="18">
                  <div class="jishi flex-row cur" @click="setStaff(item,index)">{{ item.staffName?item.staffName:'请选择' }}<div class="el-icon-arrow-right icon-rights" @click="setStaff(item,index)"></div></div>
                </el-col>
                <el-col :span="2">
                  <div @click="removeDeductStaffList(index)" class="right cur"><img src="../../assets/images/new/deleted.png" alt="" ></div>
                </el-col>
              </el-row>
              <el-row class="mt10">
                <el-col :span="4" class="">
                  <p class="label inputLable">提成:</p>
                </el-col>
                <el-col :span="20" class="">
                  <div class="value">
                    <el-input
                      placeholder="请输入"
                      v-model.trim="item.deductAmount"
                      style="width: 240px;"
                      @input="blurItem(item)"
                      maxlength="8"
                    ></el-input>
                  </div>
                </el-col>
              </el-row>
              <el-row class="mt20">
                <el-col :span="4" class="">
                  <p class="label ">社保补贴:</p>
                </el-col>
                <el-col :span="20" class="">
                  <div class="value">
                    {{ item.socialSubsidyAmount }}
                  </div>
                </el-col>
              </el-row>

            </div>
          </div>
        </div>
        <div class="drawer-footer pr24 pb10">
          <div class="btns">
            <el-button type="primary" @click="saveDeduct">确定</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <staff-set ref="deductSetForm" @staffChange="changeDeductPage"></staff-set>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import drawer from "../../components/common/drawer";
import staffSet from "../components/staff-set";
import deductSet from "../components/staff-set";
import paySuccess from "../components/pay-success";
import { decrypt, encrypt } from "../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { drawer, staffSet, paySuccess, deductSet },
  data() {
    return {
      updateTitle: "修改提成",
      deductForm: {},
      updateDeductHide: false, //修改提成
      setDeductAmount: 0,
      socialSubsidyTotalAmount: 0,
      deductStaffList: [{
          deductAmount: null,
          staffName: "",
          staffId: "",
          socialSubsidyAmount: '',
        }
      ], //提成列表
    };
  },
  created() {
    this.deductInit();
  },

  methods: {
    //  页面初始化函数
    deductInit() {
      this.$on("set", function (org) {
        console.log(org);
        this.deductForm.id = org.orderId;
        this.setDeductAmount = org.deductTotalAmount;
        this.socialSubsidyTotalAmount = org.socialSubsidyTotalAmount;
        this.updateDeductHide = true;
      });
    },
    blurItem (item) {
      // 输入验证：只允许数字和小数点，最多保留两位小数
      let value = item.deductAmount;
      
      if (!value || value === '') {
        item.socialSubsidyAmount = '';
        return;
      }
      
      // 转换为字符串
      value = String(value);
      
      // 实时过滤非法字符：只保留数字和小数点
      let filteredValue = '';
      let hasDot = false;
      
      for (let i = 0; i < value.length; i++) {
        const char = value[i];
        
        // 如果是数字，直接保留
        if (/\d/.test(char)) {
          filteredValue += char;
        }
        // 如果是小数点，且之前没有小数点，则保留
        else if (char === '.' && !hasDot) {
          filteredValue += char;
          hasDot = true;
        }
        // 其他字符（包括第二个小数点）被过滤掉
      }
      
      // 限制小数点后最多两位
      const dotIndex = filteredValue.indexOf('.');
      if (dotIndex !== -1 && filteredValue.length - dotIndex - 1 > 2) {
        filteredValue = filteredValue.substring(0, dotIndex + 3);
      }
      
      // 更新为过滤后的值
      item.deductAmount = filteredValue;
      
      // 如果过滤后的值为空或只有小数点，清空社保补贴
      if (!filteredValue || filteredValue === '.') {
        item.socialSubsidyAmount = '';
        return;
      }
      
      // 重新计算所有人的社保补贴并处理尾差
      setTimeout(() => {
        this.calculateSocialSubsidyWithDiff();
      }, 500);
    },
    calculateSocialSubsidyWithDiff () {
      if (!this.setDeductAmount || parseFloat(this.setDeductAmount) === 0) {
        // 如果提成总金额为0，则每个人的社保补贴也为0
        this.deductStaffList.forEach(item => {
          item.socialSubsidyAmount = '0.00'
        })
        return
      }
      // 计算所有设置了提成的员工的社保补贴
      let totalCalculatedSocialSubsidy = 0, totalCalculateddeductAmount = 0
      const itemsWithDeduct = this.deductStaffList.filter(item => 
        item.deductAmount !== null && item.deductAmount !== '' && !isNaN(item.deductAmount)
      )
      // 先计算除了最后一个有提成的员工外，其他所有人的社保补贴
      for (let i = 0; i < itemsWithDeduct.length; i++) {
        const item = itemsWithDeduct[i]
        
        if (totalCalculateddeductAmount == Number(this.setDeductAmount)) { //
          item.socialSubsidyAmount = this.socialSubsidyTotalAmount - totalCalculatedSocialSubsidy
          break;
        }
        
        const calculatedSocialSubsidy = (parseFloat(item.deductAmount) / parseFloat(this.setDeductAmount)) * parseFloat(this.socialSubsidyTotalAmount)
        totalCalculateddeductAmount += item.deductAmount
        totalCalculatedSocialSubsidy += item.socialSubsidyAmount
        item.socialSubsidyAmount = calculatedSocialSubsidy.toFixed(2)
      }
      
      // 处理没有设置提成的员工
      this.deductStaffList.forEach(item => {
        if (item.deductAmount === null || item.deductAmount === '' || isNaN(parseFloat(item.deductAmount))) {
          item.socialSubsidyAmount = '0.00'
        }
      })
    },
    saveDeduct() {
      if (this.deductStaffList.length <= 0) {
        this.$message.warning("请添加提成");
        return false;
      }
      for (let i in this.deductStaffList) {
        if (this.deductStaffList[i].staffName == "") {
          this.$message.warning("请选择技师");
          return false;
        } else if (this.deductStaffList[i].deductAmount == "") {
          this.$message.warning("请输入提成金额");
          return false;
        } else if (!/^(?!0+(\.0+)?$)\d+(\.\d+)?$/.test(this.deductStaffList[i].deductAmount)) {
          this.$message.warning("请输入有效的大于0的数字");
          return false;
        }
      }
      let arr = {
        orderId: this.deductForm.id,
        millisecond: new Date().getTime(),
        deductStaffList: this.deductStaffList
      };
      console.log(arr);
      this.$api.post(this.$url.orderInfo.updateDeduct, encrypt(JSON.stringify(arr))).then(res => {
          if (res) {
            this.$message.success("操作成功");
            this.back();
            this.$emit("change", this.deductForm.id);
          }
        });
    },
    addDeductStaffList() {
      this.deductStaffList.unshift({
        deductAmount: null,
        staffName: "",
        staffId: "",
        socialSubsidyAmount: '',
      });
    },
    removeDeductStaffList(index) {
      this.deductStaffList.splice(index, 1);
    },
    setStaff(item, index) {
      this.$refs["deductSetForm"].$emit("set", {
        single: true,
        staffIds: item.staffId,
        index: index
      });
    },
    changeDeductPage(org) {
      this.deductStaffList[org.nodeId].staffId = org.staffIds[0].staffId;
      this.deductStaffList[org.nodeId].staffName = org.staffIds[0].staffName;
    },
    back() {
       this.deductStaffList = [
        {
          deductAmount: null,
          staffName: "",
          staffId: "",
          socialSubsidyAmount: '',
        }
      ]
      this.setDeductAmount = 0;
      this.socialSubsidyTotalAmount = 0;
      this.updateDeductHide = false;
    }
  }
};
</script>
<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.pay-mains {
  height: 100%;
  box-sizing: border-box;
  .deduct-tops {
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 24px;
    .money {
      font-size: 18px;
      font-weight: bold;
      color: @money;
      margin-left: 9px;
    }
  }
  .rows {
    margin: 0 24px;
    border-bottom: 1px solid #eee;
    padding: 20px 0;
    .value {
      // width: 345px;
      color: #8d8d8d;
    }
    .icon-rights {
      display: flex;
      align-items: center;
      color: @blue;
      font-weight: bold;
      vertical-align: middle;
    }
    .label {
      // width: 60px;
      font-size: 16px;
      color: #666;
      font-weight: 500;
    }
    .inputLable {
      height: 40px;
      line-height: 40px;
    }
  }
  .deduct-boxs {
    background-color: #fff;
    .deduct-rows {
      .last-deduct {
        border-bottom: 1px solid #eee;
      }
      .first-deduct {
        justify-content: space-between;
        .staff-name {
          display: flex;
          flex: 1;
          justify-content: space-between;
          .cur {
            cursor: pointer;
            padding-right: 20px;
          }
        }
      }
      
    }
  }
}
</style>